import axios from 'axios';

export const createInvoice = async (
  apiUri: string,
  email: string,
  price: number,
): Promise<string> => {
  const res = await axios.post(`${apiUri}/bitpay/invoice`, {
    email,
    price,
  });
  return await res.data;
};
